import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { FallbackCallout } from './fallback-callout';

export const withFallbackCallout = (WrappedComponent) => {
  const HOC = (props) => {
    const {
      fallbackTitle,
      fallbackPlacement,
      fallbackShow,
      fallbackEnabled,
      fallbackHandleClose,
      fallbackSiteMapId,
      fallbackGetOldUIPathOverride,
      ...passThroughProps
    } = props;

    if (fallbackEnabled) {
      return (
        <FallbackCallout
          title={fallbackTitle}
          placement={fallbackPlacement}
          show={fallbackShow}
          classes={props.classes}
          handleClose={fallbackHandleClose}
          getOldUIPathOverride={fallbackGetOldUIPathOverride}
          siteMapId={fallbackSiteMapId}
        >
          <WrappedComponent {...passThroughProps} />
        </FallbackCallout>);
    }

    return (
      <WrappedComponent {...passThroughProps} />
    );
  };

  HOC.displayName = `withFallbackCallout(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  HOC.defaultProps = {
    fallbackTitle: null,
    fallbackPlacement: 'right',
    fallbackShow: null,
    fallbackEnabled: true,
    fallbackHandleClose: () => { },
    classes: {},
    fallbackSiteMapId: null,
    fallbackGetOldUIPathOverride: null,
  };

  HOC.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    classes: PropTypes.object,
    fallbackTitle: PropTypes.string,
    fallbackPlacement: PropTypes.string,
    fallbackEnabled: PropTypes.bool,
    fallbackHandleClose: PropTypes.func,
    fallbackGetOldUIPathOverride: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
    /**
     * Use this to manually control when to show the callout. This is only needed if the component
     * does not have control of its own click and press handlers.
     */
    fallbackShow: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.oneOf([null]).isRequired,
    ]),
    fallbackSiteMapId: PropTypes.string,
  };

  return HOC;
};
